import styled from 'styled-components'
import {device} from '../../media_queries'

const MainInfoP = styled.div`
  display: flex;
  font-family: 'panton-bold';
  color: #262237;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 60vh;
  border-radius: 4px;
  z-index: -1;
  &>p{
    margin-top: 10vh;
    font-size:1.5em;
    width:90vw;
    font-family: 'panton-extrabold';
  }
  @media ${device.mobileS} {
    height: auto;
  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    width: 100%;
    height: 100%;
  }
  @media ${device.desktop} {
    
  }
`
const InfoSec = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 4%;
  background-color: #ffffff;
      
    @media ${device.mobileS} {
      width:60%;
      }

    @media ${device.tablet} {
      display: flex;
      flex-wrap: wrap;
      width: 25%;

}
    @media ${device.laptop} {
    font-size: 1.5em;
    width:20vw
}
    @media ${device.desktop} {
    font-size: 1.5em;
    width:25vw
}
`
const InfoImg = styled.div`
display: flex;
justify-content: center;
height: 30vh;
background-color: #ffffff;
border: solid 1px #dfe8ee;
border-radius:30px;
padding: 5%;
color: #262237;

@media ${device.mobileS} {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  width: 50vw;
  height: auto;
  margin: 0 2% ;
  font-size: 1em;
  &>img{
    display: flex;
    height: 20vh;
  }
  &>button{
    width: 50%;
    font-size: .3rem;
    font-family: 'panton-extrabold';
  }
} 
@media ${device.tablet} {
  height: 20vh;
  width: 20vw;
  &>img{
    display: flex;
    height: 20vh;
  }
}

@media ${device.laptop} {
font-size: 1.5em;

}
@media ${device.desktop} {


}
`
const InfoTxt = styled.div`
display: flex;
justify-content: center;
flex-direction: column;
height: 15vh;
padding: 0;
color: #262237;
&>h4{
  font-size: 20px;
  font-family:'panton-black'
}

@media ${device.mobileS} {
  display: flex;
  flex-grow: 1;
  width: 100%;
}
@media ${device.tablet} {

}
@media ${device.laptop} {
}
@media ${device.desktop} {

}
`
export { MainInfoP, InfoSec, InfoImg, InfoTxt};